// WB news monitoring enums as reported by the backend (models.* in
// backend/internal/models/wb_news.go) - labels/colors only, no fields invented here.

export const RELEVANCE_LEVELS = ['direct', 'indirect', 'potential', 'unrelated'];

export const RELEVANCE_LABELS = {
  direct: 'Прямая',
  indirect: 'Косвенная',
  potential: 'Потенциальная',
  unrelated: 'Не относится',
};

export const RELEVANCE_COLORS = {
  direct: 'error',
  indirect: 'warning',
  potential: 'info',
  unrelated: 'default',
};

export const SEVERITY_LEVELS = ['critical', 'high', 'medium', 'low'];

export const SEVERITY_LABELS = {
  critical: 'Критично',
  high: 'Высокая',
  medium: 'Средняя',
  low: 'Низкая',
};

export const SEVERITY_COLORS = {
  critical: 'error',
  high: 'warning',
  medium: 'info',
  low: 'default',
};

export const WORKFLOW_STATUSES = ['new', 'reviewing', 'resolved', 'hidden'];

export const WORKFLOW_LABELS = {
  new: 'Новое',
  reviewing: 'В работе',
  resolved: 'Решено',
  hidden: 'Скрыто',
};

export const WORKFLOW_COLORS = {
  new: 'info',
  reviewing: 'warning',
  resolved: 'success',
  hidden: 'default',
};

// Kept in sync by hand with categoryLabels in backend/internal/newsfeed/classifier.go.
export const CATEGORY_LABELS = {
  api_integrations: 'API и интеграции',
  financial_reports: 'Финансовые отчёты',
  commissions_tariffs: 'Комиссии и тарифы',
  logistics: 'Логистика',
  storage: 'Хранение',
  orders_sales: 'Заказы и продажи',
  analytics: 'Аналитика',
  advertising: 'Реклама',
  technical_incidents: 'Технические инциденты',
  rules_required: 'Правила и обязательные изменения',
  other: 'Прочее',
};

export const CATEGORY_OPTIONS = Object.keys(CATEGORY_LABELS);

export const HISTORY_EVENT_LABELS = {
  created: 'Публикация создана',
  content_updated: 'Обновлено содержимое',
  reclassified: 'Изменена классификация',
  workflow_status_changed: 'Изменён статус обработки',
  important_changed: 'Изменена важность',
  action_required_changed: 'Изменён признак «требует действия»',
  read: 'Отмечено прочитанным',
  resolved: 'Отмечено решённым',
  commented: 'Добавлен комментарий',
};

// Short, human labels for the keys that show up in history old_value/new_value payloads.
export const HISTORY_FIELD_LABELS = {
  workflow_status: 'Статус',
  is_important: 'Важно',
  requires_action: 'Требует действия',
  category: 'Категория',
  change_type: 'Тип изменения',
  severity: 'Важность',
  relevance_level: 'Релевантность',
  relevance_reason: 'Причина релевантности',
  classifier_version: 'Версия классификатора',
  comment: 'Комментарий',
  content_hash: 'Хеш содержимого',
  original_text: 'Текст',
  summary: 'Краткое содержание',
  published_at: 'Дата публикации',
  read_at: 'Прочитано',
  resolved_at: 'Решено',
  resolved_by: 'Кем решено',
};

export const labelFor = (map, key) => map[key] || key;
